module.exports = __webpack_public_path__ + "img/res3.6742bdfb.jpg";